<template>
  <div class="hzc-industry-dynamics no-li">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/steel')">钢铁</span> > <span
        @click="back()" style="cursor: pointer">{{title}}</span> > 正文
    </div>
    <div class="content">
      <div class="top">
        <p>{{ row.titleName }}</p>
        <span>发布时间：{{ row.showYearTime }}</span><span>来源：{{ row.updateBy || "网络"}}</span>
      </div>
      <div class="bom" v-html="row.newsContent"></div>
    </div>
  </div>
</template>

<script>
import {
  backTwoYieldDetail,
  industryDetail,
} from '@/api/steel'

export default {
  data() {
    return {
      row: {},
      page: 1,
      size: 15,
      total: 0,
      title:'',
      flag: '2'
    }
  },
  created() {
    if (this.$route.query.flag) {
      this.flag = this.$route.query.flag;
    }
    if (this.flag === '2') {
      this.title = '行业动态'
      this.getIndustry(this.$route.query.id);
    } else if (this.flag === '3') {
      this.title = '钢厂动态'
      this.getIndustry(this.$route.query.id);
    } else if (this.flag === '7') {
      this.title = '产量'
      this.getYield(this.$route.query.id);
    } else if (this.flag === '6') {
      this.title = '产量'
      this.getYield(this.$route.query.id);
    }
  },
  methods: {
    // 行业动态
    getIndustry(pageParams) {
      industryDetail(pageParams).then(res => {
        this.row = res.data;
      })
    },
    // 产量
    getYield(pageParams) {
      backTwoYieldDetail(pageParams).then(res => {
        this.row = res.data;
      })
    },
    back(url) {
      if (url) {
        this.$router.push({path: url});
      } else {
        if (this.flag === '2' || this.flag === '3') {
          this.$router.push({path: '/steel/twoPage/industry', query:{flag:this.flag}});
        } else {
          this.$router.push({path: '/steel/twoPage/yield', query:{flag:this.flag}})
        }
      }
    },
  }
}
</script>

<style scoped lang="less">
.hzc-industry-dynamics {
  width: 1200px;
  margin: 0 auto;

  .content {
    width: 960px;
    min-height: 500px;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin:16px auto 0;

    .top {

      border-bottom: 1px solid #ccc;
      padding: 16px 0;
      text-align: center;

      p {
        color: #222;
        font-size: 24px;
      }
      span {
        display: inline-block;
        margin-right: 16px;
        color: #777777;
        font-size: 12px;
      }
    }
    .bom {
      padding:16px 40px;
      ::v-deep {
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
